<template>
  <div>
    <section class="hero is-dark">
      <div class="hero-body">
        <div class="container">
          <nav class="level is-mobile">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Ofertas de Empleo</p>
                <p class="title">{{ vacancies.length }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Hoteles</p>
                <p class="title">{{ vacancies.length }}</p>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Puestos</p>
                <p class="title">{{ vacancies.length }}</p>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </section>
    <section class="hero is-light">
      <div class="hero-body">
        <div class="container">
          <h4 class="title is-3"><img class="filter-img" :src="filterimg" alt="Filtros de Vacantes"/>Filtros</h4>
          <div class="columns mt-01">
            <div class="column">
              <div class="field">
                <label class="label">Hotel</label>
                <div class="control">
                  <input class="input" v-model="hotelname" name="hotelname" type="text" placeholder="Escriba el nombre de un hotel">
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">Puesto</label>
                <div class="control">
                  <input class="input" type="text" v-model="jobname" name="jobname" placeholder="Escriba el nombre de un puesto">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="columns mt-01">
        <div class="column">
          <table class="table table is-fullwidth table is-striped table is-bordered">
            <thead>
              <tr>
                <th>Hotel</th>
                <th>Experiencia</th>
                <th>Puesto</th>
              </tr>
            </thead>
            <tfoot>
              <tr>
                <th>Hotel</th>
                <th>Experiencia</th>
                <th>Puesto</th>
              </tr>
            </tfoot>
            <tbody>
              <tr v-for="(v, i) in filteredData">
                <th>{{v.company}}</th>
                <td>{{v.demand}}</td>
                <td>{{v.job}}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </div>


  </div>
</template>

<script>
import axios from 'axios';
import VueLodash from 'vue-lodash'
import filterimg from '@/assets/img/filterimg.png'

export default {
  name: 'Vacantes',
  data () {
    return {
      vacancies:[],
      countVacancies:0,
      filterimg:filterimg,
      hotelname:'',
      jobname:'',
    }
  },
  components: {
  },
  watch: {
  },
  computed: {
    filteredData: function () {
      if(this.hotelname){
        return this.vacancies.filter(v => {
          return v.company.toLowerCase().indexOf(this.hotelname.toLowerCase()) > -1;
        });
      }
      if(this.jobname){
        return this.vacancies.filter(v => {
          return v.job.toLowerCase().indexOf(this.jobname.toLowerCase()) > -1;
        });
      }
      return this.vacancies;
    }
  },
  methods:{
    vacanciesSearch(){
      var self = this;
      axios.post(process.env.API_URL_V1+'vacancies?api_token='+process.env.API_TOKEN_V1,{type_list:0})
      .then(function (response) {
        self.vacancies=response.data.data;
      })
      .catch(function (error) {
      });
    },
  },
  created :function(){
    this.vacanciesSearch();
  }
}
</script>

<style scoped>
.filter-img{

}
</style>



// WEBPACK FOOTER //
// src/components/Vacantes.vue